import React from "react";

export default function NotifyCenter({ message, type = "success" }) {
  return (
    <div className={`notify-toast ${type}`}>
      {message}
    </div>
  );
}
